import client from "./client";

const path = (code) => encodeURIComponent(code);

/** The favourite songs (with verses) of the host of a session. */
export const getLibrarySongs = (code) => client.get(`/Library/GetSongs/${path(code)}`).then((r) => r.data);

/** Adds a song to the session host's favourites and returns it. Idempotent, so safe to retry. Host only. */
export const addSong = (songId) => client.put(`/Library/AddSong/${songId}`, null, { retry: true }).then((r) => r.data);

/** Removes a song from the session host's favourites. Host only. */
export const removeSong = (songId) => client.delete(`/Library/RemoveSong/${songId}`, { retry: true });
